export function hasArrayChanged(array1: string[], array2: string[]): boolean {
  // Если разная длина - точно изменился
  if (array1.length !== array2.length) {
    return true
  }

  // Сортируем и сравниваем
  const sorted1 = [...array1].sort()
  const sorted2 = [...array2].sort()

  return sorted1.some((item, index) => item !== sorted2[index])
}

export function compareArrays<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) return false

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }

  return true
}
